<template>
  <validation-observer v-slot="{ invalid }">
    <v-form class="form" ref="form" lazy-validation>
      <div class="ml-16 mr-16 pl-16 pr-16">
        <div class="text-align-left pt-16 pl-16 pr-16 pa-4 mb-14">

          <question-title :question_title="formValues_a.title"></question-title>
          <check-box :name_property="formValues_a.nameProperty" :name_property_other="formValues_a.namePropertyOther" :datas="formValues_a"></check-box>

          <question-title :question_title="formValues_b.title"></question-title>
          <check-box :name_property="formValues_b.nameProperty" :name_property_other="formValues_b.namePropertyOther" :datas="formValues_b"></check-box>

          <question-title :question_title="formValues_c.title" :required_mark="formValues_c.requiredMark"></question-title>
          <radio-box :name_property="formValues_c.nameProperty" :datas="formValues_c"></radio-box>

          <question-title :question_title="formValues_d.title" :required_mark="formValues_d.requiredMark"></question-title>
          <radio-box :name_property="formValues_d.nameProperty" :datas="formValues_d"></radio-box>

          <question-title :question_title="formValues_e.title" :required_mark="formValues_e.requiredMark"></question-title>
          <radio-box :name_property="formValues_e.nameProperty" :datas="formValues_e"></radio-box>

          <question-title :question_title="formValues_f.title"></question-title>
          <check-box :name_property="formValues_f.nameProperty" :name_property_other="formValues_f.namePropertyOther" :datas="formValues_f"></check-box>

          <question-title :question_title="formValues_g.title" :required_mark="formValues_g.requiredMark"></question-title>
          <radio-box :name_property="formValues_g.nameProperty" :datas="formValues_g"></radio-box>

          <question-title :question_title="formValues_h.title"></question-title>
          <check-box :name_property="formValues_h.nameProperty" :name_property_other="formValues_h.namePropertyOther" :datas="formValues_h"></check-box>

          <question-title :question_title="formValues_i.title"></question-title>
          <check-box :name_property="formValues_i.nameProperty" :name_property_other="formValues_i.namePropertyOther" :datas="formValues_i"></check-box>

          <question-title :question_title="formValues_10.title"></question-title>
          <field-area :name_property="formValues_10.nameProperty" :datas="formValues_10"></field-area>

          <question-title :question_title="formValues_11.title"></question-title>
          <field-area :name_property="formValues_11.nameProperty" :datas="formValues_11"></field-area>

          <question-title class="ml-4" :question_title="formValues_l.title" :required_mark="formValues_l.requiredMark"></question-title>
          <radio-box :displayFlg="radioTextDisplay" :name_property="formValues_l.nameProperty" :name_property_other="formValues_l.namePropertyOther" :datas="formValues_l"></radio-box>

          <question-title class="ml-4" :question_title="formValues_m.title" :required_mark="formValues_m.requiredMark"></question-title>
          <radio-box :name_property="formValues_m.nameProperty" :datas="formValues_m"></radio-box>

          <v-divider class="my-8"></v-divider>
            <v-card-actions justify="space-between" class="mx-auto">
              <tool-button class="mx-auto" link="/" text="戻る"></tool-button>
              <v-spacer></v-spacer>
              <v-btn id="submitButton" :disabled="invalid" color="primary" large  text-align="center" @click="submit()">送信</v-btn>
            </v-card-actions>
        </div>
      </div>
    </v-form>
  </validation-observer>
</template>

<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import CheckBox from '@/components/CheckBox.vue'
import RadioBox from '@/components/RadioBox.vue'
import FieldArea from '@/components/FieldArea.vue'
import ToolButton from '@/components/ToolButton.vue'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    QuestionTitle,
    CheckBox,
    RadioBox,
    FieldArea,
    ToolButton
  },
  data () {
    return {
      invalid: false,
      radioTextDisplay: true
    }
  },
  computed: {
    // formValues_12: {
    //   get () {
    //     return this.$store.state.formValues_12
    //   },
    //   set (value) {
    //     this.$store.commit('setFormValues_12', { formValues_12: value })
    //   }
    // },
    // formValues_13: {
    //   get () {
    //     return this.$store.state.formValues_13
    //   },
    //   set (value) {
    //     this.$store.commit('setFormValues_13', { formValues_13: value })
    //   }
    // },
    formValues_a: {
      get () {
        return this.$store.state.formValues_a
      },
      set (value) {
        this.$store.commit('setFormValues_a', { formValues_a: value })
      }
    },
    formValues_b: {
      get () {
        return this.$store.state.formValues_b
      },
      set (value) {
        this.$store.commit('setFormValues_b', { formValues_b: value })
      }
    },
    formValues_c: {
      get () {
        return this.$store.state.formValues_c
      },
      set (value) {
        this.$store.commit('setFormValues_c', { formValues_c: value })
      }
    },
    formValues_d: {
      get () {
        return this.$store.state.formValues_d
      },
      set (value) {
        this.$store.commit('setFormValues_d', { formValues_d: value })
      }
    },
    formValues_e: {
      get () {
        return this.$store.state.formValues_e
      },
      set (value) {
        this.$store.commit('setFormValues_e', { formValues_e: value })
      }
    },
    formValues_f: {
      get () {
        return this.$store.state.formValues_f
      },
      set (value) {
        this.$store.commit('setFormValues_f', { formValues_f: value })
      }
    },
    formValues_g: {
      get () {
        return this.$store.state.formValues_g
      },
      set (value) {
        this.$store.commit('setFormValues_g', { formValues_g: value })
      }
    },
    formValues_h: {
      get () {
        return this.$store.state.formValues_h
      },
      set (value) {
        this.$store.commit('setFormValues_h', { formValues_h: value })
      }
    },
    formValues_i: {
      get () {
        return this.$store.state.formValues_i
      },
      set (value) {
        this.$store.commit('setFormValues_i', { formValues_i: value })
      }
    },
    formValues_10: {
      get () {
        return this.$store.state.formValues_10
      },
      set (value) {
        this.$store.commit('setFormValues_10', { formValues_10: value })
      }
    },
    formValues_11: {
      get () {
        return this.$store.state.formValues_11
      },
      set (value) {
        this.$store.commit('setFormValues_11', { formValues_11: value })
      }
    },
    formValues_l: {
      get () {
        return this.$store.state.formValues_l
      },
      set (value) {
        this.$store.commit('setFormValues_l', { formValues_l: value })
      }
    },
    formValues_m: {
      get () {
        return this.$store.state.formValues_m
      },
      set (value) {
        this.$store.commit('setFormValues_m', { formValues_m: value })
      }
    },
    formValue_host: {
      get () {
        return this.$store.state.formValues_host
      },
      set (value) {
        this.$store.commit('setFormValues_host', { formValues_host: value })
      }
    },
    hostGet () {
      const hostname = location.hostname
      return hostname
    }
  },
  methods: {
    // clear: function () {
    //   this.$router.go({ path: this.$router.currentRoute.path, force: true })
    // },
    submit: function () {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        for (const i in this.$store.state.formValues_a.saveValue) {
          formData.append(this.$store.state.formValues_a.nameProperty, this.$store.state.formValues_a.saveValue[i])
        }
        formData.append(this.$store.state.formValues_a.namePropertyOther, this.$store.state.formValues_a.saveValueOther)
        for (const i in this.$store.state.formValues_b.saveValue) {
          formData.append(this.$store.state.formValues_b.nameProperty, this.$store.state.formValues_b.saveValue[i])
        }
        formData.append(this.$store.state.formValues_b.namePropertyOther, this.$store.state.formValues_b.saveValueOther)
        formData.append(this.$store.state.formValues_c.nameProperty, this.$store.state.formValues_c.saveValue)
        formData.append(this.$store.state.formValues_d.nameProperty, this.$store.state.formValues_d.saveValue)
        formData.append(this.$store.state.formValues_e.nameProperty, this.$store.state.formValues_e.saveValue)
        for (const i in this.$store.state.formValues_f.saveValue) {
          formData.append(this.$store.state.formValues_f.nameProperty, this.$store.state.formValues_f.saveValue[i])
        }
        formData.append(this.$store.state.formValues_f.namePropertyOther, this.$store.state.formValues_f.saveValueOther)
        formData.append(this.$store.state.formValues_g.nameProperty, this.$store.state.formValues_g.saveValue)
        for (const i in this.$store.state.formValues_h.saveValue) {
          formData.append(this.$store.state.formValues_h.nameProperty, this.$store.state.formValues_h.saveValue[i])
        }
        formData.append(this.$store.state.formValues_h.namePropertyOther, this.$store.state.formValues_h.saveValueOther)
        for (const i in this.$store.state.formValues_i.saveValue) {
          formData.append(this.$store.state.formValues_i.nameProperty, this.$store.state.formValues_i.saveValue[i])
        }
        formData.append(this.$store.state.formValues_i.namePropertyOther, this.$store.state.formValues_i.saveValueOther)
        formData.append(this.$store.state.formValues_10.nameProperty, this.$store.state.formValues_10.saveValue)
        formData.append(this.$store.state.formValues_11.nameProperty, this.$store.state.formValues_11.saveValue)
        formData.append(this.$store.state.formValues_l.nameProperty, this.$store.state.formValues_l.saveValue)
        formData.append(this.$store.state.formValues_l.namePropertyOther, this.$store.state.formValues_l.saveValueOther)
        formData.append(this.$store.state.formValues_m.nameProperty, this.$store.state.formValues_m.saveValue)
        formData.append(this.$store.state.formValues_host.nameProperty, this.hostGet)
        for (var [key, value] of formData.entries()) {
          console.log(key, value)
        }
        this.$router.push('/appreciate')
        // const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/'
        // const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSfhx8Vu8UlsmPEYHIWLm9Tp5k2pYpP8Ty_aoFLBQbVSrjcqKg/formResponse'
        const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdg0V3Unt-HTuAs4fYOjbpWHo0jT76JNFniuB3oG0_xfDSepg/formResponse'
        axios.post(GOOGLE_FORM_ACTION, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res) => {
            for (var [key, value] of formData.entries()) {
              console.log(key, value)
            }
            this.$router.push('/appreciate')
          }).catch((err) => {
            console.log(err)
            if (err.response) {
              console.log(err.response.data)
              console.log(err.response.status)
              console.log(err.response.headers)
            }
            this.$router.push('/appreciate')
          })
      }
    }
  }
}
</script>